import request from '@/config/request';
import API from '@/config/domain';

export default {
  // app展示接口
  getUserAppList(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/getUserAppList', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 通知公告消息列表
  getAllMessageNoticeForUser(params, callback) {
    return request(API.BASEAPI + 'rest/drugMessageNotice/getAllMessageNoticeForUser', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 用户登录时长
  getUserLoginDuration(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/getUserLoginDuration', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 根据appId获取回调url
  getAccessUrlByAppId(params, callback) {
    return request(API.BASEAPI + 'rest/appManageInfo/getAccessUrlByAppId', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 用户退出
  logout(params, callback) {
    return request(API.BASEAPI + 'logout', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 平均登录时长
  getAvgDurationStatistics(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/getAvgDurationStatistics', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 总人数-统计
  getLoginDurationStatistics(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/getLoginDurationStatistics', 'post', params).then((data) => {
      callback(data);
    });
  },
};